import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';

@Pipe({
  name: 'locationDataParcelsSectionTitle',
  standalone: true
})
export class LocationDataParcelsSectionTitlePipe implements PipeTransform {
  transform(application?: ApplicationAppEntityApplicationRead | null): string {
    if (application?.service?.url === '/opinia-w-sprawie-wydania-decyzji') {
      return 'Działki drogowe';
    }
    switch (true) {
      case application?.applicationSubject === 'Przebudowy zjazdu': {
        return 'Działki drogowe na których jest zjazd';
      }
      default: {
        return 'Działki drogowe na których będzie projektowany zjazd';
      }
    }
  }
}
